module.exports = __webpack_public_path__ + "Public/Home/staticmokao/img/part9.267cc7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/part9.jpg
// module id = JnIR
// module chunks = 1